import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import * as lookup from "../../../static/lookup.json"
import Select from "react-select"
import { SectionContext } from "../context/sectionContext"
import { ConditionContext } from "../context/conditionContext"
import { ErrorContext } from "../context/errorContext"
import {JourneyContext} from "../context/journeyContext"
import { getValueFromLookup, productRenderChecker,getValueFromJourney } from "../services/helperFunctions"
import { BranchDetailsContext } from "../context/branchDetailsContext"
import { errorToastr, successToastr, clearToastr } from "../../services/error-handler"
import { lineCapital } from "../../shared/functions"
import { FixedSizeList as List } from 'react-window';
import {debounce} from "lodash";
import { fetchBranchDetails } from "../../services/apiservice"

const SelectContainer = styled.div`
  display: block;
  flex-direction: column;
  margin: 14px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;
  min-width: 100%;
  max-width: 100%;

  & > .css-2b097c-container {
    margin-top: -17px;
    
    
    

    & div.css-1pahdxg-control{
      background: ${props => props.channel === "A" ? "#ededed" :  "#fff"} !important;
      background: var(--lumiq-bg) !important;
    }

    & > div {
      border-radius: 0;
      border: 1px solid #929292;
      padding: 0.6rem 0;
      padding-bottom: 0;
      
    }
    .css-1uccc91-singleValue{
      color:inherit;
      font-size: 1rem;
    }

    & div.css-yk16xz-control{
      background: ${props => props.channel === "A" ? "#ededed" :  "#fff"};
      background: var(--lumiq-bg);
    

      .css-1hb7zxy-IndicatorsContainer > div{
        padding: 0 !important;        
        padding-right: 4px !important;        
      }
    }
    .css-1gtu0rj-indicatorContainer{
      padding: 0 !important;
      padding-right: 4px !important;
    }
    & > div.css-26l3qy-menu {
      z-index: 500 !important;
      background: ${props => props.channel === "A" ? "#ededed" :  "#fff"};
      background:var(--lumiq-bg)
    }

    & > div {
      box-shadow: none !important;
      border: 1px solid #929292;
    }
    & .css-1okebmr-indicatorSeparator {
      background: transparent;
    }
  }

  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background: ${props => props.channel === "A" ? "#ededed" :  "#fff"};
    background: var(--lumiq-bg);
    padding: 2px 5px;
    z-index: 1;
    position: relative;
    display: inline-block;
    cursor: default;
  }
`
// const customStyles = {
//   option: (provided) => ({
//     ...provided,
//     // padding: 0,
//     zIndex:9999
//   }),
//   control: () => ({
//     // display:'flex'
//     // none of react-select's styles are passed to <Control />
//   }),
//   input:()=>({

//   }),
//   singleValue: (provided, state) => {
//     // const opacity = state.isDisabled ? 0.5 : 1;
//     // const transition = 'opacity 300ms';

//     // return { ...provided, opacity, transition };
//   }
// }


export default function ComponentTextSelect(props) {
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [errorState, setErrorState] = useContext(ErrorContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [branchDetailsState, setBranchDetailsState] = useContext(BranchDetailsContext)

  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const branchMapper = {
    cityName: "BRANCH_CITY",
    canaraBankBranchId: "BRANCH_ID",
    branchName: "BRANCH_NAME"
  }
  const [searchKey, setSearchKey] = useState('BRANCH_CITY');
  useEffect(() => {
    if (!searchTerm || (searchTerm && searchTerm.length < 2)) {
      return;
    }
    setIsLoading(true);
    const debouncedFetchBranchDetails = debounce(async () => {
      try {
        const res = await fetchBranchDetails(searchTerm, searchKey);
        if (res?.data?.length > 0) {
          const branchNameArray = Array.from(
            new Map(
              res.data.map(details => [details.BRANCH_NAME, { value: details.BRANCH_NAME, label: details.BRANCH_NAME }])
            ).values()
          ).sort((a, b) => a.label.localeCompare(b.label)); // Sort alphabetically by `label`

          const branchIdsArray = Array.from(
            new Map(
              res.data.map(details => [details.BRANCH_ID, { value: details.BRANCH_ID, label: details.BRANCH_ID }])
            ).values()
          ).sort((a, b) => Number(a.label) - Number(b.label));

          const branchCitiesArray = res.data.map(details => {
            return {
              value: details.BRANCH_CITY,
              label: details.BRANCH_CITY
            }
          })
          const distinctCities = branchCitiesArray
            .filter((item, index, self) =>
              index === self.findIndex((obj) => obj.value === item.value)
            )
            .sort((a, b) => a.value.localeCompare(b.value));
          setBranchDetailsState({
            branchDetails: res.data,
            branchNames: branchNameArray,
            branchIds: branchIdsArray,
            branchCities: distinctCities

          })
        }
      } catch (error) {
        console.error("Error fetching branch details:", error);
        errorToastr("No matching city/branch found.")
      } finally {
        setIsLoading(false)
      }
    }, 500)
    debouncedFetchBranchDetails();
    return () => debouncedFetchBranchDetails.cancel();
  }, [searchTerm, searchKey])

  const validate = (target) =>  {
    if(props.data.required){ // required field validation
      if(sectionState.sectionData && ((sectionState.sectionData[props.data.formControlKey] === "") || (!sectionState.sectionData[props.data.formControlKey]))){
        setErrorState( prev => {
          return ({
            ...prev,
            // [props.data.formControlKey]: props.data.requiredError ? props.data.requiredError : `Please select ${props.data.label}`
            [props.data.formControlKey]: props.data.requiredError
            ? lineCapital(getValueFromLookup(
              "required_error",
              props.data.requiredError
            )): `Error Code Not Found in Strapi`,
          })
        })
      }else{
        setErrorState(prev => {
          return({
            ...prev,
            [props.data.formControlKey]: ""
          })
        })
      }
      if(target.value){
        setErrorState(prev => {
          return({
            ...prev,
            [props.data.formControlKey]: ""
          })
        })
      }
    }
    return
  }

  useEffect(() => {
    validate({value: sectionState.sectionData?.[props.data.formControlKey]?? ""})
    console.log(props?.data?.formControlKey,['1','2','3','D'].includes(sectionState.sectionData?.[props.data.formControlKey]), sectionState.sectionData?.[props.data.formControlKey], )
    if(props?.data?.formControlKey === "educationalQualification" && sectionState.sectionData?.[props.data.formControlKey] && sectionState.sectionId === "CPPersonalDetailsSection"){
      if(/*sectionState.sectionData["contactCountryCode"] === "+91" &&*/ !(['1','2','3','D'].includes(sectionState.sectionData?.[props.data.formControlKey]))){
        setErrorState( prev => {
          // errorToastr(journeyState.planOption)
          return ({
            ...prev,
            [props.data.formControlKey]: `This option is not available for this plan`
          })
        })
        return
      }
      // else if (sectionState.sectionData["contactCountryCode"] !== "+91" && !(['1','2'].includes(sectionState.sectionData?.[props.data.formControlKey]))){
      //   setErrorState( prev => {
      //     // errorToastr(journeyState.planOption)
      //     return ({
      //       ...prev,
      //       [props.data.formControlKey]: `This option is not available for this plan`
      //     })
      //   })
      //   return
      // }
    }
    // if(props.data.formControlKey === "contactCountryCode" && sectionState.sectionData?.[props.data.formControlKey] && sectionState.sectionId === "CPPersonalDetailsSection"){
    //   if(sectionState.sectionData[props.data.formControlKey] === "+91" && sectionState.sectionData["educationalQualification"] === "D" && errorState["educationalQualification"] === "This option is not available for this plan"){
    //     setErrorState( prev => {
    //       // errorToastr(journeyState.planOption)
    //       return ({
    //         ...prev,
    //         ["educationalQualification"]: ""
    //       })
    //     })
    //     return
    //   }else if(sectionState.sectionData[props.data.formControlKey] !== "+91" && sectionState.sectionData["educationalQualification"] === "D"){
    //     setErrorState( prev => {
    //       // errorToastr(journeyState.planOption)
    //       return ({
    //         ...prev,
    //         ["educationalQualification"]: `This option is not available for this plan`
    //       })
    //     })
    //     return
    //   }
    // }
    console.log(conditionState, sectionState, props, "componentSelect type")
    if(props.data?.businessRuleCheck){
      props.businessRule(props.data.formControlKey)
    }
    if(props?.data?.formControlKey === "education" && sectionState.sectionData?.[props.data.formControlKey] && sectionState.sectionId === "spouseQuestionnaire"){
      if(sectionState.sectionData["residentStatus"] === "N" && !(['1','2','3','D'].includes(sectionState.sectionData?.[props.data.formControlKey]))){
        setErrorState( prev => {
          // errorToastr(journeyState.planOption)
          return ({
            ...prev,
            [props.data.formControlKey]: `This option is not available for this plan`
          })
        })
        return
      }else if (sectionState.sectionData["residentStatus"] !== "N" && !(['1','2'].includes(sectionState.sectionData?.[props.data.formControlKey]))){
        setErrorState( prev => {
          // errorToastr(journeyState.planOption)
          return ({
            ...prev,
            [props.data.formControlKey]: `This option is not available for this plan`
          })
        })
        return
      }
    }
    if(props.data.formControlKey === "residentStatus" && sectionState.sectionData?.[props.data.formControlKey] && sectionState.sectionId === "spouseQuestionnaire"){
      if(sectionState.sectionData[props.data.formControlKey] === "N" && ['3', '4'].includes(sectionState.sectionData["education"]) && errorState["education"] === "This option is not available for this plan"){
        setErrorState( prev => {
          // errorToastr(journeyState.planOption)
          return ({
            ...prev,
            ["education"]: ""
          })
        })
        return
      }else if(sectionState.sectionData[props.data.formControlKey] !== "N" && ['3', '4'].includes(sectionState.sectionData["education"])){
        setErrorState( prev => {
          // errorToastr(journeyState.planOption)
          return ({
            ...prev,
            ["education"]: `This option is not available for this plan`
          })
        })
        return
      }
    }
    // if(props?.data?.formControlKey === "education" && sectionState.sectionData?.[props.data.formControlKey] && !(['1','2','D'].includes(sectionState.sectionData?.[props.data.formControlKey]))){
    //   setErrorState( prev => {
    //     // errorToastr(journeyState.planOption)
    //     return ({
    //       ...prev,
    //       [props.data.formControlKey]: `This option is not available for this plan`
    //     })
    //   })
    //   return
    // }
    if((props.journeyIdFromStrapi === "ISelect360Journey" && props.sectionId === "iSelect360CPResidentAndOccupationDetailSection" || 
         props.journeyIdFromStrapi === "youngTermPlanJourney" && props.sectionId === "youngTermCPResidentAndOccupationDetailSection" )
      && props.data.formControlKey === "residentStatus" && (sectionState.sectionData["gstWaiverInd"] === "Y"
      && sectionState.sectionData["residentStatus"] !== "Y")){
      setSectionState((prev) => {
        return ({
          ...prev,
          sectionData: {
            ...prev.sectionData,
            "gstWaiverInd": "N"
          },
        })
      })
      props.saveApplicationAndCallBi("gstWaiverInd", "N");
    }
    if(sectionState.sectionData?.[props.data.formControlKey] && sectionState.sectionId === "iSelect360CPResidentAndOccupationDetailSection" && props?.data?.formControlKey === "residentStatus"){
      let educationalQualification = conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.educationalQualification"]
      let annualIncome = conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.AnnualIncome"]
      if(["Y", "S", "F"].includes(sectionState.sectionData?.[props.data.formControlKey])){
        if((!["1", "2"].includes(educationalQualification)) || annualIncome < 1000000){
          setErrorState( prev => {
            // errorToastr(journeyState.planOption)
            return ({
              ...prev,
              [props.data.formControlKey]: `This option is not available for this plan`
            })
          })
          return
        }
      }
    }
    if(sectionState.sectionData?.[props.data.formControlKey] && sectionState.sectionId === "youngTermCPResidentAndOccupationDetailSection" && props?.data?.formControlKey === "residentStatus"){
      let educationalQualification = conditionState["PageYoungTermCalculatePremium.sectionYoungTermPersonalDetailsSection.educationalQualification"]
      let annualIncome = conditionState["PageYoungTermCalculatePremium.sectionYoungTermPersonalDetailsSection.AnnualIncome"]
      if(["Y", "S", "F"].includes(sectionState.sectionData?.[props.data.formControlKey])){
        if((!["1", "2"].includes(educationalQualification)) || annualIncome < 1000000){
          setErrorState( prev => {
            // errorToastr(journeyState.planOption)
            return ({
              ...prev,
              [props.data.formControlKey]: `This option is not available for this plan`
            })
          })
          return
        }
      }
    }
    if(props?.data?.formControlKey === "CPResidentAndOccupationType" && sectionState.sectionData?.[props.data.formControlKey] && !(['1','3'].includes(sectionState.sectionData?.[props.data.formControlKey]))){
      setErrorState( prev => {
        // errorToastr(journeyState.planOption)
        return ({
          ...prev,
          [props.data.formControlKey]: `This option is not available for this plan`
        })
      })
      return
    }
    if(props.data.formControlKey === "AppointeeFullNameTitle" && sectionState.sectionData["AppointeeFullNameTitle"]){
      autoFill({value: sectionState.sectionData["AppointeeFullNameTitle"]})
    }
    if(props.data.formControlKey === "fullNameTitle" && sectionState.sectionData && sectionState.sectionData["fullNameTitle"] && journeyState.journeyIdFromStrapi == "GuaranteedSavingJourney" && props.sectionId == "SectionPOSNomineeDetails"){
      autoFill({value: sectionState.sectionData["fullNameTitle"]})
    }
     // For Spouse Age proof dropdown change based on country code
     if((journeyState.journeyIdFromStrapi == "ISelect360Journey" || journeyState.journeyIdFromStrapi == "youngTermPlanJourney") && (props.sectionId == "spouseQuestionnaire" && props?.data?.formControlKey === "countryCode"))
     {
       let temp = journeyState.journeySteps
       let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "pageISelect360FillProposalForm")
       let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "spouseQuestionnaire")
       let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "ageProof-order-15")
       let tempComponentIndexToChangeAgeProof = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "ageProof")
       let spouselookupKeyForAgeProof
       if(sectionState.sectionData["countryCode"] === "+91") {
        spouselookupKeyForAgeProof = "AGE_PROOF_IN"
       } else {
        spouselookupKeyForAgeProof = "AGE_PROOF_NON_IN"
       }
       temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeAgeProof]["lookupKey"] = spouselookupKeyForAgeProof
       setJourneyState(prev => {
         return ({
           ...prev,
           journeySteps: temp
         })
       })
       setSectionState((prev) => {
        return ({
          ...prev,
          sectionData: {
            ...prev.sectionData,
            ["ageProof"]: ""
          },
        })
      })
     }

     //For state autoFill in residential and occupationDetail
     if(props.data.formControlKey.toLowerCase().includes("country") && (props.sectionId === "CPResidentAndOccupationDetailSection" || props.sectionId === "iSelect360CPResidentAndOccupationDetailSection")){
       autoFill({value: sectionState.sectionData["country"]})
     }
     
  },[sectionState.sectionData?.[props.data.formControlKey]])
  
  useEffect(() => {
    if ((props.sectionId === "youngTermCPResidentAndOccupationDetailSection" || props.sectionId === "iSelect360CPResidentAndOccupationDetailSection") && (props.data.formControlKey =="CPResidentAndOccupationType" || props.data.formControlKey =="CPResidentAndOccupationNatureIndustries") ) {
      let lookup
     if(props.data.formControlKey =="CPResidentAndOccupationType"){
      if((conditionState["PageYoungTermCalculatePremium.sectionYoungTermPersonalDetailsSection.gender"]=== "M") || (conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.gender"] === "M")){
        lookup = "occupationForMale"
      }else if((conditionState["PageYoungTermCalculatePremium.sectionYoungTermPersonalDetailsSection.gender"]=== "F") ||(conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.gender"] === "F")|| (((conditionState["PageYoungTermCalculatePremium.sectionYoungTermPersonalDetailsSection.gender"] === "T") || (conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.gender"] === "T")))){
        lookup = "occupation"
      }
        let temp = journeyState.journeySteps
        let tempPageIndexFillProposalForm = temp.pages.findIndex(element => element.pageId === props.pageId)
        let tempSectionIndexFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections.findIndex(element => element.sectionId === props.sectionId)
        let tempComponentGroupFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "youngtermPlanCPResidentAndOccupationDetail" || element.componentId === "iSelect360CPResidentAndOccupationDetail")
        let tempComponentFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components.findIndex(element => element.formControlKey === "CPResidentAndOccupationType")
        temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["lookupKey"] = lookup
        if (sectionState.sectionData[props.data.formControlKey] === "4") {
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["CPResidentAndOccupationType"]: "",
              }
            })
          })
        }
      }else if(props.data.formControlKey =="CPResidentAndOccupationNatureIndustries"){
        if((conditionState["PageYoungTermCalculatePremium.sectionYoungTermPersonalDetailsSection.gender"]=== "M") || (conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.gender"] === "M")){
          lookup = "natureOfOccupationForMale"
        }else if((conditionState["PageYoungTermCalculatePremium.sectionYoungTermPersonalDetailsSection.gender"]=== "F")|| (conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.gender"] === "F") || (conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.gender"] === "T") || (((conditionState["PageYoungTermCalculatePremium.sectionYoungTermPersonalDetailsSection.gender"] === "T")))){
          lookup = "natureOfOccupation"
        }
        let temp = journeyState.journeySteps
        let tempPageIndexFillProposalForm = temp.pages.findIndex(element => element.pageId === props.pageId)
        let tempSectionIndexFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections.findIndex(element => element.sectionId === props.sectionId)
        let tempComponentGroupFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "youngtermPlanCPResidentAndOccupationDetail" || element.componentId === "iSelect360CPResidentAndOccupationDetail") 
        let tempComponentFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components.findIndex(element => element.formControlKey === "CPResidentAndOccupationNatureIndustries" )
        temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["lookupKey"] = lookup
        if (sectionState.sectionData[props.data.formControlKey] === "77") {
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["CPResidentAndOccupationNatureIndustries"]: "",
              }
            })
          })
        }
     }

    }
  },[])
  

  //To select value to india for as country code
  useEffect(() => {
    if(!sectionState.sectionData?.[props.data.formControlKey]){
      if(props.data.defaultValue){ // remove this condition && props.sectionId === "CPPersonalDetailsSection"  === "contactCountryCode"
        setSectionState((prev) => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: props.data.defaultValue
            },
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: props.data.defaultValue,
          }
        })
      }
      // else if(props.data.formControlKey === "AppointeeFullNameTitle"){
      //   setSectionState((prev) => {
      //     return ({
      //       ...prev,
      //       sectionData: {
      //         ...prev.sectionData,
      //         [props.data.formControlKey]: "MR"
      //       },
      //     })
      //   })
      //   setConditionState(prev => {
      //     return {
      //       ...prev,
      //       [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "MR",
      //     }
      //   })
      // }

      if(((conditionState["calculatePremiumPage.CPPersonalDetailsSection.contactCountryCode"] === "+91" || conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.contactCountryCode"] === "+91" ) && props.sectionId !== "CPPersonalDetailsSection") || (conditionState["PageYoungTermCalculatePremium.sectionYoungTermPersonalDetailsSection.contactCountryCode"] === "+91" && props.sectionId !== "sectionYoungTermPersonalDetailsSection")){
        if(props.sectionId === "personalDetailsSection" && (props.data.formControlKey === "AlternateMobCountryCode")){
          setSectionState((prev) => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: "+91"
              },
            })
          })
        }
        else if(props.data.formControlKey != "countryCode" && props.data.formControlKey.toLowerCase().includes("country") || props.data.formControlKey === "residentialCitizenship" || props.data.formControlKey === "residentialNationality"){
          setSectionState((prev) => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: "IN"
              },
            })
          })
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "IN",
            }
          })
        }else if(props.data.formControlKey === "residentStatus"){
          setSectionState((prev) => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: "N"
              },
            })
          })
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "N",
            }
          })
        }
      }else{
        if(props.sectionId === "personalDetailsSection" && (props.data.formControlKey === "AlternateMobCountryCode")){
          setSectionState((prev) => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: props.journeyIdFromStrapi === "iSelectJourney" ? conditionState["calculatePremiumPage.CPPersonalDetailsSection.contactCountryCode"] : props.journeyIdFromStrapi === "ISelect360Journey" ? conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.contactCountryCode"] :  props.journeyIdFromStrapi === "youngTermPlanJourney" ? conditionState["PageYoungTermCalculatePremium.sectionYoungTermPersonalDetailsSection.contactCountryCode"] : "+91"
              },
            })
          })
        }else if((props.data.formControlKey.toLowerCase().includes("country") || props.data.formControlKey === "residentialCitizenship" || props.data.formControlKey === "residentialNationality") && props.sectionId !== "CPPersonalDetailsSection"  && props.sectionId !== "sectionYoungTermPersonalDetailsSection"  && props.sectionId !== "SectionGuaranteedSavingPersonaldetails" && props.sectionId !== "SectionPOSNomineeDetails"){
          setSectionState((prev) => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: props.journeyIdFromStrapi === "iSelectJourney" ? getValueFromLookup("countryCodeToCountry", conditionState["calculatePremiumPage.CPPersonalDetailsSection.contactCountryCode"]) : props.journeyIdFromStrapi === "ISelect360Journey" ? getValueFromLookup("countryCodeToCountry", conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.contactCountryCode"]): props.journeyIdFromStrapi === "youngTermPlanJourney" ? conditionState["PageYoungTermCalculatePremium.sectionYoungTermPersonalDetailsSection.contactCountryCode"] : "IN"
              },
            })
          })
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: props.journeyIdFromStrapi === "iSelectJourney" ? getValueFromLookup("countryCodeToCountry", conditionState["calculatePremiumPage.CPPersonalDetailsSection.contactCountryCode"]) : props.journeyIdFromStrapi === "ISelect360Journey" ? getValueFromLookup("countryCodeToCountry", conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.contactCountryCode"]): props.journeyIdFromStrapi === "youngTermPlanJourney" ? conditionState["PageYoungTermCalculatePremium.sectionYoungTermPersonalDetailsSection.contactCountryCode"] : "IN",
            }
          })
          autoFill({})
        }else if(props.data.formControlKey === "residentStatus"){
          setSectionState((prev) => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: "Y"
              },
            })
          })
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "Y",
            }
          })
        }
      }
      
    }
    // For Spouse Occupation Dropdown based on occupation selection of previous section
    if((journeyState.journeyIdFromStrapi == "ISelect360Journey" || journeyState.journeyIdFromStrapi == "youngTermPlanJourney") && (props.sectionId == "spouseQuestionnaire"))
    {
      let temp = journeyState.journeySteps
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "pageISelect360FillProposalForm")
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "spouseQuestionnaire")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "occupation-order-9")
      let tempComponentIndexToChangeOccupation = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "occupation")  
      let spouseOccupationType
      if (journeyState.journeyIdFromStrapi == "ISelect360Journey" ){
        spouseOccupationType = conditionState["PageISelect360CalculatePremium.iSelect360CPSpouseCoverDetails.CPSpouseOccupationQuestion"]
      }else{
        spouseOccupationType = conditionState["PageYoungTermCalculatePremium.youngTermCPSpouseCoverDetails.CPSpouseOccupationQuestion"]
      }
      let spouselookupKeyForOccupation
      if(spouseOccupationType && (spouseOccupationType === "NW")) {
        spouselookupKeyForOccupation = "occupation_SPOUSE_NONWORKING"
      } else {
        spouselookupKeyForOccupation = "occupation_SPOUSE_WORKING"
      }
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeOccupation]["lookupKey"] = spouselookupKeyForOccupation
      setJourneyState(prev => {
        return ({
          ...prev,
          journeySteps: temp
        })
      })
    }

  }, [props.sectionId])

  const updateSectionState = (branchDetail,path) => {
    if(path ==="cityName"){
      const filterBranches= branchDetailsState.branchDetails.filter((branch) => branch.BRANCH_CITY === branchDetail.BRANCH_CITY);
      
      const transformedBranchName = Array.from(
        new Map(filterBranches.map(branch => [branch.BRANCH_NAME, { 
            value: branch.BRANCH_NAME, 
            label: branch.BRANCH_NAME 
        }])).values()
      ).sort((a, b) => a.label.localeCompare(b.label)); 
      
      const transformedBranchId = Array.from(
        new Map(filterBranches.map(branch => [branch.BRANCH_ID, { 
            value: branch.BRANCH_ID, 
            label: branch.BRANCH_ID 
        }])).values()
      ).sort((a, b) => Number(a.label) - Number(b.label)); 
      
      setBranchDetailsState(prev => ({
        ...prev,
        branchNames:transformedBranchName,
        branchIds:transformedBranchId
      }))
      if(transformedBranchName.length === 1){
        setSectionState((prev) => ({
          ...prev,
          sectionData: {
            ...prev.sectionData,
            "branchName": transformedBranchName[0].value,
            "canaraBankBranchId": transformedBranchId[0].value,
          },
        }));
      }
      else{
        setSectionState((prev) => ({
          ...prev,
          sectionData: {
            ...prev.sectionData,
            "cityName": branchDetail.BRANCH_CITY,
            "canaraBankBranchId": "",
            "branchName": "",
          },
        }));
      }
      return;
    }
    setSectionState((prev) => ({
      ...prev,
      sectionData: {
        ...prev.sectionData,
        "branchName": branchDetail.BRANCH_NAME,
        "canaraBankBranchId": branchDetail.BRANCH_ID,
        "cityName": branchDetail.BRANCH_CITY
      },
    }));
  };

  const handleChange = target => {
    if (sectionState.sectionId === props.sectionId) {
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: target.value,
          },
        }
      })
    } else {
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: props.sectionId,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: target.value,
          },
        }
      })
    }
    setConditionState(prev => {
      return {
        ...prev,
        [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: target.value,
      }
    })
    // console.log(conditionState, "dhdhdj")
    validate(target)
    if(props.saveApplicationAndCallBi){
      props.saveApplicationAndCallBi(props.data.formControlKey, target.value)
    }

    if (props.data.formControlKey === "contactCountryCode"){
      setSectionState(prev => {
        return {
          ...prev,
          sectionData : {
            ...prev.sectionData,
            "contactNumber" : "",
            "numberMask" : ""
          }
        }
      })
    }

    if (props.data.formControlKey === "AlternateMobCountryCode"){
      setSectionState(prev => {
        return {
          ...prev,
          sectionData : {
            ...prev.sectionData,
            "AlternateMobNumber" : "",
            "AlternateMobNumbermask" : ""
          }
        }
      })
    }

    const { formControlKey } = props.data;
    let branchDetail
    const branchDetails =  branchDetailsState.branchDetails;
    if (formControlKey === "branchName") {
      branchDetail = branchDetails.find(detail => detail.BRANCH_NAME === target.value);
    } else if (formControlKey === "canaraBankBranchId") {
      branchDetail = branchDetails.find(detail => detail.BRANCH_ID === target.value);
    } else if (formControlKey === "cityName") {
      branchDetail = branchDetails.find(detail => detail.BRANCH_CITY === target.value);
    }
    const path = formControlKey;
    if (branchDetail) {
      updateSectionState(branchDetail,path);
    }
  }

  const autoFill = (target) => {
    if(props.data.formControlKey.toLowerCase() === "prcountry"){
      if(props.sectionId === "residenceDetailsSection"){
        let temp = journeyState.journeySteps
        let tempPageIndexToChange
        let fillProposalPageId
        let tempSectionIndexToChange
        let tempComponentGroupIndexToChange
        let tempComponentGroupIndexToChangeForState
       if(props.journeyIdFromStrapi === "ISelect360Journey" || journeyState.journeyIdFromStrapi == "youngTermPlanJourney"){
          tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "pageISelect360FillProposalForm")
          fillProposalPageId = "pageISelect360FillProposalForm"
          tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "residenceDetailsSection")
          tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "permanentResidentialDetails")
          tempComponentGroupIndexToChangeForState = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "permanentResidentialDetails")
        }
        
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "PRPincode")
        console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "temp data")
        let tempComponentIndexToChangeForState = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeForState].components.findIndex(element => element.formControlKey === "PRState")

        //To Change pincode validation in fill proposal form
        let tempPageIndexFillProposalForm = temp.pages.findIndex(element => element.pageId === fillProposalPageId) // validate dynamic pageid
        let tempSectionIndexFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections.findIndex(element => element.sectionId === "residenceDetailsSection")
        let tempComponentGroupFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "permanentResidentialDetails")
        let tempComponentFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components.findIndex(element => element.formControlKey === "PRPincode")
        console.log(tempPageIndexFillProposalForm, tempSectionIndexFillProposalForm, tempComponentGroupFillProposalForm, tempComponentFillProposalForm,   "dfefd1")

        if(sectionState.sectionData[props.data.formControlKey] !== "IN"){
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["PRState"]: "NR",
              }
            })
          })
         
          //Freezing State key
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeForState].components[tempComponentIndexToChangeForState]["disabled"] = true

          //ValidationsFor fill proposal form
          temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["min_len"] = 3
          temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["max_length"] = 9
          temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["regex"] = "/^[a-zA-Z0-9 \-\/]+$/"
          temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["__typename"] = "ComponentCmpTagTextString"
          
          console.log(temp, "iimp")

          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })

        }else{
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["PRPincode"]: "",
                ["PRState"]: "",
              }
            })
          })

          let temp = journeyState.journeySteps
          console.log(temp, "dfg")
          
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeForState].components[tempComponentIndexToChangeForState]["disabled"] = false

          //ValidationsFor fill proposal form
          temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["min_len"] = 6
          temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["regex"] = null
          temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["__typename"] = "ComponentCmpTagNumber"
          console.log(temp, "iimp")
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }
      }
    }
    else if(props.data.formControlKey.toLowerCase().includes("country")){
      if(props.sectionId === "CPResidentAndOccupationDetailSection" || 
      props.sectionId === "iSelect360CPResidentAndOccupationDetailSection" || props.sectionId === "youngTermCPResidentAndOccupationDetailSection" ){

        //Temp Indexes will be used either in if or else
        let temp = journeyState.journeySteps
        let tempPageIndexToChange
        let fillProposalPageId
        let tempSectionIndexToChange
        let tempComponentGroupIndexToChange
        let tempComponentGroupIndexToChangeForState
        if(props.journeyIdFromStrapi === "ISelect360Journey"){
          tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageISelect360CalculatePremium")
          fillProposalPageId = "pageISelect360FillProposalForm"
          tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "iSelect360CPResidentAndOccupationDetailSection")
          tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "iSelect360CPResidentAndOccupationDetail")
          tempComponentGroupIndexToChangeForState = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "iSelect360CPResidentAndOccupationDetail")
        }else if(props.journeyIdFromStrapi === "youngTermPlanJourney"){
          tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageYoungTermCalculatePremium")
          fillProposalPageId = "pageISelect360FillProposalForm"
          tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "youngTermCPResidentAndOccupationDetailSection")
          tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "youngtermPlanCPResidentAndOccupationDetail")
          tempComponentGroupIndexToChangeForState = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "youngtermPlanCPResidentAndOccupationDetail")
        }
        
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "pincode")
        console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "temp data")
        let tempComponentIndexToChangeForState = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeForState].components.findIndex(element => element.formControlKey === "state")

        //To Change pincode validation in fill proposal form
        let tempPageIndexFillProposalForm = temp.pages.findIndex(element => element.pageId === fillProposalPageId) // validate dynamic pageid
        let tempSectionIndexFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections.findIndex(element => element.sectionId === "residenceDetailsSection")
        let tempComponentGroupFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "pinCode")
        let tempComponentFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components.findIndex(element => element.formControlKey === "pincode")
        console.log(tempPageIndexFillProposalForm, tempSectionIndexFillProposalForm, tempComponentGroupFillProposalForm, tempComponentFillProposalForm,   "dfefd1")

        if(sectionState.sectionData[props.data.formControlKey] !== "IN"){
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["state"]: "NR",
              }
            })
          })
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len"] = 3
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_length"] = 9
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = "/^[a-zA-Z0-9 \-\/]+$/"
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagTextString"

          //Freezing State key
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeForState].components[tempComponentIndexToChangeForState]["disabled"] = true

          //ValidationsFor fill proposal form
          temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["min_len"] = 3
          temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["max_length"] = 9
          temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["regex"] = "/^[a-zA-Z0-9 \-\/]+$/"
          temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["__typename"] = "ComponentCmpTagTextString"
          
          console.log(temp, "iimp")

          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })

        }else{
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["state"]: "",
              }
            })
          })

          let temp = journeyState.journeySteps
          console.log(temp, "dfg")
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len"] = 6
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = null
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagNumber"

          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeForState].components[tempComponentIndexToChangeForState]["disabled"] = false

          //ValidationsFor fill proposal form
          temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["min_len"] = 6
          temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["regex"] = null
          temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["__typename"] = "ComponentCmpTagNumber"
          console.log(temp, "iimp")
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }
      }
      else if(props.sectionId === "SectionPOSCommunicationAddress"){
        let temp = journeyState.journeySteps
        let tempPageIndexToChange
        if(props.journeyIdFromStrapi === "GuaranteedSavingJourney"){
          tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PagePOSFillProposalForm")
        }
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionPOSCommunicationAddress")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "permanentResidentialDetailsWithLandMark-MD-12-Order")
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "PRPincode")
        let tempComponentIndexToChangeForState = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "PRState")
        //console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, tempComponentIndexToChangeForState,"GSP Communication")
       
        if(sectionState.sectionData[props.data.formControlKey] && sectionState.sectionData[props.data.formControlKey] !== "IN"){
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["PRState"]: "NR",
              }
            })
          })
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len"] = 1
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_length"] = 9
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = "/^[a-zA-Z0-9]+$/"
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagNumber"
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeForState]["lookupKey"]  = "state"
          //Freezing State key
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeForState]["disabled"] = true

          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })

        }else{
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["PRState"]: "",
              }
            })
          })

          let temp = journeyState.journeySteps
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len"] = 6
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = null
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagNumber"
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeForState]["disabled"] = false
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeForState]["lookupKey"]  = "state_RM"
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }
      }
      else if(props.sectionId === "SectionPOSOccupationDetails"){
        let temp = journeyState.journeySteps
        let tempPageIndexToChange
        if(props.journeyIdFromStrapi === "GuaranteedSavingJourney"){
          tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PagePOSFillProposalForm")
        }
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionPOSOccupationDetails")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "officePincode-MD-4-Order-11")
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "pincode")
        let tempComponentGroupIndexToChangeForState = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "officeState-MD-4-Order-12")
        let tempComponentIndexToChangeForState = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeForState].components.findIndex(element => element.formControlKey === "state")
        console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, tempComponentGroupIndexToChangeForState, tempComponentIndexToChangeForState,"GSP Occupation")
       
        if(sectionState.sectionData[props.data.formControlKey] && sectionState.sectionData[props.data.formControlKey] !== "IN"){
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["state"]: "NR",
              }
            })
          })
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len"] = 1
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_length"] = 9
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = "/^[a-zA-Z0-9]+$/"
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagNumber"

          //Freezing State key
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeForState].components[tempComponentIndexToChangeForState]["disabled"] = true
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeForState].components[tempComponentIndexToChangeForState]["lookupKey"] = "state"

          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })

        }else{
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["state"]: "",
              }
            })
          })

          let temp = journeyState.journeySteps
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len"] = 6
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = null
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagNumber"
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeForState].components[tempComponentIndexToChangeForState]["disabled"] = false
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeForState].components[tempComponentIndexToChangeForState]["lookupKey"] = "state_RM"         
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }
      }
      else if(props.sectionId === "SectionPOSProposerDetails"){
      
        let temp = journeyState.journeySteps
        let tempPageIndexToChange
        if( props.journeyIdFromStrapi === "GuaranteedSavingJourney"){
          tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PagePOSFillProposalForm")
        }
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionPOSProposerDetails")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "employerLocation")
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "employerPincode")
        let tempComponentIndexToChangeForState = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "employerState")
        //console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, tempComponentIndexToChangeForState,"GSP Communication")
       
        if(sectionState.sectionData[props.data.formControlKey] && sectionState.sectionData[props.data.formControlKey] !== "IN"){
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["employerState"]: "NR",
              }
            })
          })
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len"] = 1
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_length"] = 9
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = "/^[a-zA-Z0-9]+$/"
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagNumber"
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeForState]["lookupKey"]  = "state"
          //Freezing State key
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeForState]["disabled"] = true
  
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
  
        }else{
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["PRState"]: "",
              }
            })
          })
  
          let temp = journeyState.journeySteps
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len"] = 6
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = null
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagNumber"
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeForState]["disabled"] = false
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeForState]["lookupKey"]  = "state_RM"
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }
      }
    }
  else if(sectionState.sectionId==="residenceDetailsSection"){
    if(!(sectionState.sectionData["permanentAddressProof"] && sectionState.sectionData["PRAddressProof"])){
      setErrorState( prev => {
        return ({
        ...prev,
        ["permanentAddressProof"]: ""
        })
      })
    }
    else if(sectionState.sectionData["PRAddressProof"] === sectionState.sectionData["permanentAddressProof"]){
      errorToastr("Current Address and Permanent Address proof cannot be same")
      setErrorState( prev => {
        return ({
        ...prev,
        ["permanentAddressProof"]: "Current Address and Permanent Address proof cannot be same"
        })
      })
    }
    else if(sectionState.sectionData["PRAddressProof"]=== "21" && sectionState.sectionData["permanentAddressProof"]=== "17"){
      errorToastr("Current Address and Permanent Address proof cannot be same")
      setErrorState( prev => {
        return ({
        ...prev,
        ["permanentAddressProof"]: "Current Address and Permanent Address proof cannot be same"
        })
      })
    }
    else if(sectionState.sectionData["permanentAddressProof"]=== "21" && sectionState.sectionData["PRAddressProof"]=== "17"){
      errorToastr("Current Address and Permanent Address proof cannot be same")
      setErrorState( prev => {
        return ({
        ...prev,
        ["permanentAddressProof"]: "Current Address and Permanent Address proof cannot be same"
        })
      })
    }
    else{
      setErrorState( prev => {
        return ({
        ...prev,
        ["permanentAddressProof"]: ""
        })
      })
    }
}
    else if(props.data.formControlKey.toLowerCase().includes("cpresidentandoccupationtype")){
      if(props.sectionId === "CPResidentAndOccupationDetailSection" || props.sectionId === "iSelect360CPResidentAndOccupationDetailSection" ||  props.sectionId === "youngTermCPResidentAndOccupationDetailSection"){

        let temp = journeyState.journeySteps
        let pageIdToChange
        let sectionIdToChange
        let componentIdToChange
        let pageIdForNatureOfIndustry= "pageISelect360FillProposalForm"
        let sectionForNatureOFIndustry= "sectionISelect360ProfessionalDetail"
        if (props.journeyIdFromStrapi === "iSelectJourney") {
          pageIdToChange = "calculatePremiumPage"
          sectionIdToChange = "CPResidentAndOccupationDetailSection"
          componentIdToChange = "CPResidentAndOccupationDetail"
        } else if (props.journeyIdFromStrapi === "ISelect360Journey") {
          pageIdToChange = "PageISelect360CalculatePremium"
          sectionIdToChange = "iSelect360CPResidentAndOccupationDetailSection"
          componentIdToChange = "iSelect360CPResidentAndOccupationDetail"
        } else if (props.journeyIdFromStrapi === "youngTermPlanJourney") {
          pageIdToChange = "PageYoungTermCalculatePremium"
          sectionIdToChange = "youngTermCPResidentAndOccupationDetailSection"
          componentIdToChange = "youngtermPlanCPResidentAndOccupationDetail"
        }

        let lookupForExactNatureofDuties= "natureOfOccupation"
        let lookupforNatureofIndustry= "natureOfIndustry"
      if(sectionState.sectionData[props.data.formControlKey] === "5"){
        lookupForExactNatureofDuties = "natureOfDutieslookupforStudent"
        lookupforNatureofIndustry = "natureOfIndustryLookupForStudent"
      }else if(sectionState.sectionData[props.data.formControlKey] === "9"){
        lookupForExactNatureofDuties = "natureOfDutieslookupforUnemployed"
      }

        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageIdToChange)
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionIdToChange)
        let tempPageIndexToFillProposal= temp.pages.findIndex(element => element.pageId === pageIdForNatureOfIndustry)
        let tempSectionIndexToFillProposal=temp.pages[tempPageIndexToFillProposal].sections.findIndex(element => element.sectionId === sectionForNatureOFIndustry)
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentIdToChange)
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "CPResidentAndOccupationNatureIndustries")
        let tempComponentGroupIndexForNatureOfIndustry = temp.pages[tempPageIndexToFillProposal].sections[tempSectionIndexToFillProposal].component_groups.findIndex(element => element.componentId === "occupationalDetails")
        let tempComponentIndexToChangeForNatureOfIndustry = temp.pages[tempPageIndexToFillProposal].sections[tempSectionIndexToFillProposal].component_groups[tempComponentGroupIndexForNatureOfIndustry].components.findIndex(element => element.formControlKey === "professionalIndustryEmployer")
        console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "temp data")
        // console.log(sectionState.sectionData[props.data.formControlKey], "gfg")
        if(sectionState.sectionData[props.data.formControlKey] === "1"){
          // console.log("salaried")
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["CPResidentAndOccupationNatureIndustries"]: "611",
                ["professionalIndustryEmployer"]: "05"
              }
            })
          })
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
          temp.pages[tempPageIndexToFillProposal].sections[tempSectionIndexToFillProposal].component_groups[tempComponentGroupIndexForNatureOfIndustry].components[tempComponentIndexToChangeForNatureOfIndustry]["disabled"] = false
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfOccupation"
          temp.pages[tempPageIndexToFillProposal].sections[tempSectionIndexToFillProposal].component_groups[tempComponentGroupIndexForNatureOfIndustry].components[tempComponentIndexToChangeForNatureOfIndustry]["lookupKey"] = "natureOfIndustry"
          console.log(temp, "iimp")

          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }else if(sectionState.sectionData[props.data.formControlKey] === "4"){
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["CPResidentAndOccupationNatureIndustries"]: "77",
                ["professionalIndustryEmployer"]: "05"
              }
            })
          })
          temp.pages[tempPageIndexToFillProposal].sections[tempSectionIndexToFillProposal].component_groups[tempComponentGroupIndexForNatureOfIndustry].components[tempComponentIndexToChangeForNatureOfIndustry]["disabled"] = true
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfOccupation"
          temp.pages[tempPageIndexToFillProposal].sections[tempSectionIndexToFillProposal].component_groups[tempComponentGroupIndexForNatureOfIndustry].components[tempComponentIndexToChangeForNatureOfIndustry]["lookupKey"] = "natureOfIndustry"
          console.log(temp, "iimp")

          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })

        }else if(sectionState.sectionData[props.data.formControlKey] === "6"){
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["CPResidentAndOccupationNatureIndustries"]: "664",
                ["professionalIndustryEmployer"]: "05"
              }
            })
          })
          temp.pages[tempPageIndexToFillProposal].sections[tempSectionIndexToFillProposal].component_groups[tempComponentGroupIndexForNatureOfIndustry].components[tempComponentIndexToChangeForNatureOfIndustry]["disabled"] = true
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfOccupation"
          temp.pages[tempPageIndexToFillProposal].sections[tempSectionIndexToFillProposal].component_groups[tempComponentGroupIndexForNatureOfIndustry].components[tempComponentIndexToChangeForNatureOfIndustry]["lookupKey"] = "natureOfIndustry"
          console.log(temp, "iimp")

          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })

        }
        else if(sectionState.sectionData[props.data.formControlKey] === "9"){
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["CPResidentAndOccupationNatureIndustries"]: "664",
                ["professionalIndustryEmployer"]: "05"
              }
            })
          })
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfDutieslookupforUnemployed"
          temp.pages[tempPageIndexToFillProposal].sections[tempSectionIndexToFillProposal].component_groups[tempComponentGroupIndexForNatureOfIndustry].components[tempComponentIndexToChangeForNatureOfIndustry]["disabled"] = true
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
          temp.pages[tempPageIndexToFillProposal].sections[tempSectionIndexToFillProposal].component_groups[tempComponentGroupIndexForNatureOfIndustry].components[tempComponentIndexToChangeForNatureOfIndustry]["lookupKey"] = "natureOfIndustry"
          console.log(temp, "iimp")

          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }
        else if (sectionState.sectionData[props.data.formControlKey] === "5") {
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["CPResidentAndOccupationNatureIndustries"]: "",
                ["professionalIndustryEmployer"]: ""
              }
            })
          })
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfDutieslookupforStudent"
          temp.pages[tempPageIndexToFillProposal].sections[tempSectionIndexToFillProposal].component_groups[tempComponentGroupIndexForNatureOfIndustry].components[tempComponentIndexToChangeForNatureOfIndustry]["lookupKey"] = "natureOfIndustryLookupForStudent"
          temp.pages[tempPageIndexToFillProposal].sections[tempSectionIndexToFillProposal].component_groups[tempComponentGroupIndexForNatureOfIndustry].components[tempComponentIndexToChangeForNatureOfIndustry]["disabled"] = false
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }
        else{
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["CPResidentAndOccupationNatureIndustries"]: "",
                  ["professionalIndustryEmployer"]: ""
              }
            })
          })
          temp.pages[tempPageIndexToFillProposal].sections[tempSectionIndexToFillProposal].component_groups[tempComponentGroupIndexForNatureOfIndustry].components[tempComponentIndexToChangeForNatureOfIndustry]["disabled"] = false
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfOccupation"
          temp.pages[tempPageIndexToFillProposal].sections[tempSectionIndexToFillProposal].component_groups[tempComponentGroupIndexForNatureOfIndustry].components[tempComponentIndexToChangeForNatureOfIndustry]["lookupKey"] = "natureOfIndustry"
          console.log(temp, "iimp")

          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }
      }
    }
    else if(props.data.formControlKey === "occupation" && props.sectionId == "spouseQuestionnaire") {
        let temp = journeyState.journeySteps
        let tempPageIndexToChange
        if(props.journeyIdFromStrapi === "ISelect360Journey" || journeyState.journeyIdFromStrapi == "youngTermPlanJourney"){
          tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "pageISelect360FillProposalForm")
        }
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "spouseQuestionnaire")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "natureOfOccupation-order-10")
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "Exactnatureoccupation")
        //console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "FOR GSP")
        if(sectionState.sectionData[props.data.formControlKey] === "1"){
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["Exactnatureoccupation"]: "611",
              }
            })
          })
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        } 
        else if(sectionState.sectionData[props.data.formControlKey] === "4"){
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["Exactnatureoccupation"]: "77",
              }
            })
          })
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }
        else if(sectionState.sectionData[props.data.formControlKey] === "6"){
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["Exactnatureoccupation"]: "664",
              }
            })
          })
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }
        else{
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["Exactnatureoccupation"]: "",
              }
            })
          })
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }
    }
    else if(props.data.formControlKey.toLowerCase() === "occupation") {
      if (props.sectionId == "iSelect360CPSpouseCoverDetails"){

        let temp = journeyState.journeySteps
        let tempPageIndexToChange
        if(props.journeyIdFromStrapi === "ISelect360Journey"){
          tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageISelect360CalculatePremium")
        }
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "iSelect360CPSpouseCoverDetails")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "spousetelemr")
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "Exactnatureoccupation")
  
        if(sectionState.sectionData[props.data.formControlKey] === "4"){
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["Exactnatureoccupation"]: "77",
              }
            })
          })
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }
        else if(sectionState.sectionData[props.data.formControlKey] === "6"){
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["Exactnatureoccupation"]: "664",
              }
            })
          })
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }
      }
  }
    else if(props.data.formControlKey === "AppointeeFullNameTitle" && journeyState.journeyIdFromStrapi !== "GuaranteedSavingJourney"){ 
      let fillProposalPageId
      if(journeyState.journeyIdFromStrapi === "iSelectJourney"){
          fillProposalPageId = "fillProposalForm"
      }else if(journeyState.journeyIdFromStrapi === "ISelect360Journey" || journeyState.journeyIdFromStrapi == "youngTermPlanJourney"){
          fillProposalPageId = "pageISelect360FillProposalForm"
      }
      let gender
      let lookup
      if(sectionState.sectionData["AppointeeFullNameTitle"] === "MR"){
        gender = "M"
        lookup = "appointeeRelationshipWithNomineeMale"
      }else if (sectionState.sectionData?.["AppointeeFullNameTitle"] === "MS" || sectionState.sectionData?.["AppointeeFullNameTitle"] === "MRS"){
        gender = "F"
        lookup = "appointeeRelationshipWithNomineeFemale"
      }
      if(sectionState.sectionData["gender"] && sectionState.sectionData["gender"] === "T"){
        gender = "T"
        lookup = "appointeeRelationshipWithNominee"
      }
      let temp = journeyState.journeySteps
      let tempPageIndexFillProposalForm = temp.pages.findIndex(element => element.pageId === fillProposalPageId) // validate dynamic pageid
      let tempSectionIndexFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections.findIndex(element => element.sectionId === "AppointeeDetailSection")
      let tempComponentGroupFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "gender")
      let tempComponentFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components.findIndex(element => element.formControlKey === "gender")

      let tempComponentGroupIdRelation = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "AppointeeRelationshipWithUser")
      let tempComponentIdRelation = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupIdRelation].components.findIndex(element => element.formControlKey === "AppointeeRelationWithUser")
      console.log(tempPageIndexFillProposalForm, tempSectionIndexFillProposalForm, tempComponentGroupFillProposalForm, tempComponentFillProposalForm,   "dfefd1")
      // temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["disabled"] = true
      temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupIdRelation].components[tempComponentIdRelation]["lookupKey"] = lookup
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: props.sectionId,
          sectionData: {
            ...prev.sectionData,
            ["gender"]: gender,
          },
        }
      })
      setConditionState(prev => {
        return {
          ...prev,
          [`${props.pageId}.${props.sectionId}.gender`]: gender,
        }
      })
      if(errorState["gender"]){
        setErrorState( prev => {
          return ({
            ...prev,
            ["gender"]: ""
          })
        })
        // if(sectionState.sectionData["gender"] && sectionState.sectionData["gender"][props.index]){
        //   if(sectionState.sectionData["gender"][props.index] === "M" && sectionState.sectionData["nomineeFullNameTitle"][props.index] === "MR")
        // }
      }
      setJourneyState(prev => {
        return ({
          ...prev,
          journeySteps: temp
        })
      })
    }
    else if(journeyState.journeyIdFromStrapi == "GuaranteedSavingJourney" && props.sectionId == "SectionPOSNomineeDetails") {
      if(props.data.formControlKey === "fullNameTitle"){ 
        let gender
        let lookup
        if(sectionState.sectionData["fullNameTitle"] === "MR"){
          gender = "M"
          lookup = "nomineeRelationshipWithLAMale"
        }else if (sectionState.sectionData?.["fullNameTitle"] === "MS" || sectionState.sectionData?.["fullNameTitle"] === "MRS"){
          gender = "F"
          lookup = "nomineeRelationshipWithLAFemale"
        }
        if(sectionState.sectionData["gender"] && sectionState.sectionData["gender"] === "T"){
          gender = "T"
          lookup = "nomineeRelationshipWithLA"
        }
        let temp = journeyState.journeySteps
        let tempPageIndexFillProposalForm = temp.pages.findIndex(element => element.pageId === "PagePOSFillProposalForm")
        let tempSectionIndexFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections.findIndex(element => element.sectionId === "SectionPOSNomineeDetails")
        let tempComponentGroupFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "gender")
        let tempComponentFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components.findIndex(element => element.formControlKey === "gender")
  
        let tempComponentGroupIdRelation = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "nomineeRelationshipWithUser")
        let tempComponentIdRelation = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupIdRelation].components.findIndex(element => element.formControlKey === "nomineeRelationshipWithUser")
        console.log(tempPageIndexFillProposalForm, tempSectionIndexFillProposalForm, tempComponentGroupFillProposalForm, tempComponentFillProposalForm,   "dfefd1")
        // temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["disabled"] = true
        temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupIdRelation].components[tempComponentIdRelation]["lookupKey"] = lookup
        setSectionState(prev => {
          return {
            ...prev,
            sectionId: props.sectionId,
            sectionData: {
              ...prev.sectionData,
              ["gender"]: gender,
            },
          }
        })
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.gender`]: gender,
          }
        })
        if(errorState["gender"]){
          setErrorState( prev => {
            return ({
              ...prev,
              ["gender"]: ""
            })
          })
        }
      }
      else if(props.data.formControlKey === "AppointeeFullNameTitle"){ 
        let gender
        let lookup
        if(sectionState.sectionData["AppointeeFullNameTitle"] === "MR"){
          gender = "M"
          lookup = "appointeeRelationshipWithNomineeMale"
        }else if (sectionState.sectionData?.["AppointeeFullNameTitle"] === "MS" || sectionState.sectionData?.["AppointeeFullNameTitle"] === "MRS"){
          gender = "F"
          lookup = "appointeeRelationshipWithNomineeFemale"
        }
        if(sectionState.sectionData["gender"] && sectionState.sectionData["gender"] === "T"){
          gender = "T"
          lookup = "appointeeRelationshipWithNominee"
        }
        let temp = journeyState.journeySteps
        let tempPageIndexFillProposalForm = temp.pages.findIndex(element => element.pageId === "PagePOSFillProposalForm")
        let tempSectionIndexFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections.findIndex(element => element.sectionId === "SectionPOSNomineeDetails")
        let tempComponentGroupFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "appointeeDetailsOverall-MD-12-Order-7")
        let tempComponentFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components.findIndex(element => element.formControlKey === "appointeeGender")
  
        let tempComponentGroupIdRelation = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "appointeeRelationshipWithLA-MD-6-Order-8")
        let tempComponentIdRelation = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupIdRelation].components.findIndex(element => element.formControlKey === "AppointeeRelationWithUser")
        console.log(tempPageIndexFillProposalForm, tempSectionIndexFillProposalForm, tempComponentGroupFillProposalForm, tempComponentFillProposalForm,   "dfefd1")
        // temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["disabled"] = true
        temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupIdRelation].components[tempComponentIdRelation]["lookupKey"] = lookup
        setSectionState(prev => {
          return {
            ...prev,
            sectionId: props.sectionId,
            sectionData: {
              ...prev.sectionData,
              ["appointeeGender"]: gender,
            },
          }
        })
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.appointeeGender`]: gender,
          }
        })
        if(errorState["gender"]){
          setErrorState( prev => {
            return ({
              ...prev,
              ["appointeeGender"]: ""
            })
          })
        }
      }
    }
    else if(journeyState.journeyIdFromStrapi == "GuaranteedSavingJourney" && props.sectionId == "SectionPOSProposerDetails") {
      if(props.data.formControlKey === "fullNameTitle"){ 
        let gender
        let lookup
        if(sectionState.sectionData["fullNameTitle"] === "MR"){
          gender = "M"
          lookup = "proposerRelationshipWithLAMale"
        }else if (sectionState.sectionData?.["fullNameTitle"] === "MS" || sectionState.sectionData?.["fullNameTitle"] === "MRS"){
          gender = "F"
          lookup = "proposerRelationshipWithLAFemale"
        }
        if(sectionState.sectionData["gender"] && sectionState.sectionData["gender"] === "T"){
          gender = "T"
          lookup = "proposerRelationshipWithLA"
        }
        let temp = journeyState.journeySteps
        let tempPageIndexFillProposalForm = temp.pages.findIndex(element => element.pageId === "PagePOSFillProposalForm")
        let tempSectionIndexFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections.findIndex(element => element.sectionId === "SectionPOSProposerDetails")
        let tempComponentGroupFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "gender-proposer-MD-6-Order-4(with margin fix class)")
        let tempComponentFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components.findIndex(element => element.formControlKey === "gender")
  
        let tempComponentGroupIdRelation = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "proposerRelationshipWithLA")
        let tempComponentIdRelation = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupIdRelation].components.findIndex(element => element.formControlKey === "proposerRelationshipWithLife")
        console.log(tempPageIndexFillProposalForm, tempSectionIndexFillProposalForm, tempComponentGroupFillProposalForm, tempComponentFillProposalForm,   "dfefd1")
        // temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["disabled"] = true
        temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupIdRelation].components[tempComponentIdRelation]["lookupKey"] = lookup
        setSectionState(prev => {
          return {
            ...prev,
            sectionId: props.sectionId,
            sectionData: {
              ...prev.sectionData,
              ["gender"]: gender,
            },
          }
        })
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.gender`]: gender,
          }
        })
        if(errorState["gender"]){
          setErrorState( prev => {
            return ({
              ...prev,
              ["gender"]: ""
            })
          })
        }
      }
    }
    else if(props.data.formControlKey === "InsureSmartOccupation" || props.data.formControlKey === "occupation") {
      if(props.sectionId === "SectionGuaranteedSavingPersonaldetails"){
        let temp = journeyState.journeySteps
        let tempPageIndexToChange
        if(props.journeyIdFromStrapi === "GuaranteedSavingJourney"){
          tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageGuaranteedSavingCalculatePremium")
        }
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionGuaranteedSavingPersonaldetails")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "natureOfOccupation/duties-MD-6-order-13.1")
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "InsureSmartExactOccupation")
        //console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "FOR GSP")
        if(sectionState.sectionData[props.data.formControlKey] === "1"){
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["InsureSmartExactOccupation"]: "611",
              }
            })
          })
          // Hide a disable dropodown
          //temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }else{
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["InsureSmartExactOccupation"]: "",
              }
            })
          })
          //temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }
      }
      if(props.sectionId === "SectionPOSOccupationDetails"){
        let temp = journeyState.journeySteps
        let tempPageIndexToChange
        if(props.journeyIdFromStrapi === "GuaranteedSavingJourney"){
          tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PagePOSFillProposalForm")
        }
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionPOSOccupationDetails")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "exactNatureOfOccupation-MD-6-Order-1")
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "exactNatureOfOccupation")
        console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "FOR GSP")
        if(sectionState.sectionData[props.data.formControlKey] === "1"){
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["exactNatureOfOccupation"]: "611",
              }
            })
          })
          //temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }else{
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["exactNatureOfOccupation"]: "",
              }
            })
          })
          //temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }
      }
    }
  }

  // const getSelectedValue = () => {
  //   let key = Object.keys(props.options).filter(function(key) {return props.options[key] === sectionState.sectionData[props.data.formControlKey] })[0];
  //   console.log(key,"dhbe")
  //   return key
  // }
  function getKeyByValue(object, value) {
    return object.find(key => key.value == value)
  }
  let options = props.options
  console.log("options",options);
   options = Object.entries(options).map(([key, val]) => ({
    value: key,
    label: val,
  }))

  if (props?.data?.formControlKey === "prrofIdAge"){
    const topElements = [];
    const endElements = [];
    
    options.forEach(option => {
      if (lookup.NSAP_AGE_PROOF[0].hasOwnProperty(option.value)) { // push age proof which are nsap at the end
        endElements.push(option);
      } else {
        topElements.push(option);
      }
    });
    options = [...topElements,...endElements]
  }
  
  if (props.data.formControlKey === "branchName"){
    options = branchDetailsState.branchNames
  }
  if (props.data.formControlKey === "cityName"){
    options = branchDetailsState.branchCities
  }
  if (props.data.formControlKey === "canaraBankBranchId"){
    options = branchDetailsState.branchIds
  }
  if (["cityName","branchName","canaraBankBranchId"].includes(props.data.formControlKey)){
    const MenuList = (props) => {
      const { options, children, maxHeight, getValue } = props;
      const height = 45; 
    
   
      const [value] = getValue();
      const initialOffset = options.indexOf(value) * height;
      if (props?.isLoading) {
        return <div style={{ padding: "10px", color: "#999" }}>Loading...</div>;
      }

      if (!props?.isLoading && children?.key === null) {
        return <div style={{ padding: "10px", color: "#999" }}>No options found</div>;
      }
      return (
        <List
          height={maxHeight}
          itemCount={children.length}
          itemSize={height}
          initialScrollOffset={initialOffset}
          width="100%"
        >
          {({ index, style }) => (
            <div style={style}>{children[index]}</div>
          )}
        </List>
      );
    };
     return (
      <>
      <SelectContainer channel={props.channel} className={`input-container ${props.data.disabled?'disable-input':''} ${props.data?.freeze?'freeze-input':''}` }>
        <label htmlFor={props.data.label} className="input-label">
         
          {/* {props.data.label} */}
          {(getValueFromLookup(
          "label",
          props.data.label
        )) || props.data.label}
        </label>
        <Select
          options={options}
          name={props.data.label}
          key={props.data.formControlKey}
          id="InputSelect"
          required={props.data.required}
          onChange={handleChange}
          onInputChange={(value) => { setSearchKey(branchMapper[props?.data?.formControlKey]); setSearchTerm(value) }}
          isLoading={isLoading}
        
          tabIndex={props.data.disabled || props.data?.freeze?-1:0}
          value={
            sectionState.sectionData?.[props.data.formControlKey]
              ? getKeyByValue(
                  options,
                  sectionState.sectionData[props.data.formControlKey]
                )
              : ""
          }
          onBlur={e => autoFill(e.target)}
          components={{ MenuList }}
          menuShouldScrollIntoView={false}
        ></Select>
        <span className="input-error">
          {props.showError && errorState[props.data.formControlKey]}
        </span>
      </SelectContainer>
    </>
     )
  }

  return (
    <>
      <SelectContainer channel={props.channel} className={`input-container ${props.data.disabled?'disable-input':''} ${props.data?.freeze?'freeze-input':''}` }>
        <label htmlFor={props.data.label} className="input-label">
         
          {/* {props.data.label} */}
          {(getValueFromLookup(
          "label",
          props.data.label
        )) || props.data.label}
        </label>
        <Select
          // className="form-control"
          // styles={customStyles}
          options={options}
          name={props.data.label}
          key={props.data.formControlKey}
          id="InputSelect"
          required={props.data.required}
          onChange={handleChange}
          // className={props.data.disabled?"disable-input":""}
          tabIndex={props.data.disabled || props.data?.freeze?-1:0}
          // value={
          //   sectionState.sectionData[props.data.formControlKey]
          //     ? getKeyByValue(
          //         options,
          //         sectionState.sectionData[props.data.formControlKey]
          //       )
          //     : ""
          // }
          value={
            sectionState.sectionData?.[props.data.formControlKey]
              ? getKeyByValue(
                  options,
                  sectionState.sectionData[props.data.formControlKey]
                )
              : ""
          }
          onBlur={e => autoFill(e.target)}
        ></Select>
        <span className="input-error">
          {props.showError && errorState[props.data.formControlKey]}
        </span>
      </SelectContainer>
    </>
  )
}
